/**  Custom components stores services types constant */
import LogoRequestList from "../../features/LogoRequestList/LogoRequestList";

/** Styles */
import "./dashboard.style.css";

const Dashboard = () => {
  return (
    <>
      <main className="container-fluid dashboard-bg">
        <div className="main main-app p-3 p-lg-4">
          <LogoRequestList />
        </div>
      </main>
    </>
  );
};

export default Dashboard;
